'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["resolveReport", "setRecordCount", "getVisualization", "onDrilldown", "report"];
import Report from '../../../../reports/inferLogic/Report';
import { isTable, fillDateRangeToReport } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const PAGE_LIMIT = 10;
const SalesAnalyticsReport = _ref => {
  let {
      resolveReport,
      setRecordCount,
      getVisualization,
      onDrilldown,
      report
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const limit = report.getIn(['config', 'limit'], PAGE_LIMIT);
  return /*#__PURE__*/_jsx(Report, Object.assign({
    report: fillDateRangeToReport(report)
  }, rest, {
    resolve: reportToResolve => resolveReport(isTable(reportToResolve) ? reportToResolve.setIn(['config', 'limit'], limit) : reportToResolve).then(data => {
      if (setRecordCount) {
        setRecordCount(data.getIn(['primary', 'data', 'paginationSize']));
      }
      return data;
    }),
    determineVisualization: getVisualization && ((reportToViz, data) => getVisualization(reportToViz, data, {
      onDrilldown
    }))
  }));
};
export default SalesAnalyticsReport;